export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '查询时间',
		align: 'center',
		dataIndex: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '查询类型',
		align: 'center',
		dataIndex: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '就诊人姓名',
		align: 'center',
		dataIndex: 'injuredName',
	},
	{
		title: '就诊人电话',
		align: 'center',
		dataIndex: 'injuredPhone',
	},
	{
		title: '查询人',
		align: 'center',
		dataIndex: 'creatorName',
	},
	{
		title: '分支公司',
		align: 'center',
		dataIndex: 'companyName',
	},
	{
		title: '状态',
		align: 'center',
		dataIndex: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
